import { render, staticRenderFns } from "./UserChangePassword.vue?vue&type=template&id=77bc4c38&scoped=true&"
import script from "./UserChangePassword.vue?vue&type=script&lang=ts&"
export * from "./UserChangePassword.vue?vue&type=script&lang=ts&"
import style0 from "./user-change-password.scss?vue&type=style&index=0&id=77bc4c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc4c38",
  null
  
)

export default component.exports